import React, { useEffect, useState } from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";

function Navbar({ openEnquiry }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top custom-navbar ${
        scrolled ? "scrolled" : ""
      }`}
    >
      <div className="container">

        {/* Logo */}
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src={logo} alt="Kashi Lighting" className="navbar-logo" />
        </a>
 <li className="nav-item">
             <Link className="nav-link" to="/projects">
Your Trust our Mission
</Link>
</li>


        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Links */}
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav align-items-lg-center">

            <li className="nav-item">
              <a className="nav-link" href="#indoor-lighting">
                Indoor
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#outdoor-lighting">
                Outdoor
              </a>
            </li>

            <li className="nav-item">
             <Link className="nav-link" to="/projects">
  Project Gallery
</Link>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#clients">
                Clients
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#about">
                About
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact
              </a>
            </li>

            <li className="nav-item ms-lg-3">
              <button
                className="enquiry-btn"
                onClick={openEnquiry}
              >
                Enquiry
              </button>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;